import { fun_PostAction } from "@/api";
import RecordDirectlyLogsDetails from "./details/index.vue";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 原始主键
      originalId: null,
      // 查询表单绑定值
      form: {
        prjName: null // 工程名称
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "工程名称",
          prop: "prjName",
          isShow: true,
          fixed: true,
          minWidth: "280"
        },
        {
          label: "记录日期",
          prop: "insertDate",
          width: "170"
        },
        {
          label: "监管部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "建设单位",
          prop: "buildCorp",
          width: "250"
        },
        {
          label: "立项批准文号",
          prop: "noteNumber",
          width: "150"
        },
        {
          label: "施工单位",
          prop: "constructionUnitName",
          width: "250"
        },
        {
          label: "计划工期（日历天）",
          prop: "planTimeLimit",
          width: "170"
        },
        {
          label: "工程造价（万元）",
          prop: "projectCost",
          width: "150"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },
  // 注册组件
  components: {
    RecordDirectlyLogsDetails // 详情
  },
  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/recordDirectlyLogs/list", {
        ...this.form,
        ...this.reqPageData,
        originalId: this.originalId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 打开弹窗
      this.$refs.recordDirectlyLogsDetails.dialogVisible = true;
      // 设置主键
      this.$refs.recordDirectlyLogsDetails.id = e.val.id;
      // 请求接口
      this.$refs.recordDirectlyLogsDetails.fun_GetDetail();
    }
  }
};
